import React, { useContext, useState, useEffect } from "react";
import "../../Organiser/Events/Events.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCalendarDays,
  faEllipsis,
  faSterlingSign,
  faTicket,
  faCoins,
  faLocationDot,
} from "@fortawesome/free-solid-svg-icons";
import eventPic from "../../../../assets/concert.png";
import jobPic from "../../../../assets/job.png";
import religiousPic from '../../../../assets/religious.png'
import charityPic from '../../../../assets/charity.png'
import sportsPic from '../../../../assets/sports.png'
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import LoadingScreen from "../../../../LoadingScreen";
import UserContext from "../../../../UserContext";
import './MyTickets.css'
import TicketContext from "./TicketContext";
import ViewTicket from "./ViewTicket";

const MyTickets = () => {

    const [activeOption, setActiveOption] = useState("active");
    const { userInfo } = useContext(UserContext);
    const [isLoading, setIsLoading] = useState(true);
    const [tickets,setTickets] = useState(null);
    const [totalActiveExpiredTickets,setTotalActiveExpiredTickets] = useState({active:0,expired:0});
    const {showTicket, handleShowTicket,getTicketDetails,currTicket} = useContext(TicketContext)
  


    const getTickets = async () => {
        try{
            const resp = await axios.get(`https://event-finder12.onrender.com/ticket/getTicketForUser/${userInfo.email}`)
            setTotalActiveExpiredTickets({ active: resp.data.activeTickets.length, expired: resp.data.expiredTickets.length });
            setTickets(resp.data);
            setIsLoading(false);
        } catch(err) {
            console.log(err);
        }
    }
  
   
    const handleOptions = (e) => {
      setActiveOption(e.target.id);
      console.log(e.target.id);
    };
  
  
    useEffect(() => {
      getTickets();
    }, []); 
  

    const handleViewTicket = (id) => {
      getTicketDetails(id)
    };

  return (
    <>
    <ToastContainer/>
    {!showTicket  && (
        <>
          {isLoading ? (
           <LoadingScreen/>
          ) : (
            <>
              <div className="event-outer-container">
                <div className="event-settings-container">
                  <div className="event-header">
                    <div className="event-header-title">
                      <h3>Your Tickets</h3>
                    </div>
                  </div>
                  <div className="event-options">
                    <div
                      onClick={handleOptions}
                      id="active"
                      className={`event-option ${activeOption === "active" ? "active-option" : ""}`}
                    >
                      <h4 id="active" className="event-option-title">
                        Upcoming events
                      </h4>
                      <h5 id="active" className="event-option-length">
                        {totalActiveExpiredTickets.active}
                      </h5>
                    </div>
                    <div
                      onClick={handleOptions}
                      id="expired"
                      className={`event-option ${activeOption === "expired" ? "active-option" : ""}`}
                    >
                      <h4 id="expired" className="event-option-title">
                        Past Events
                      </h4>
                      <h5 id="expired" className="event-option-length">
                        {/* {!expiredEvents.length ? 0 : expiredEvents.length} */}
                        {totalActiveExpiredTickets.expired}
                      </h5>
                    </div>
                  </div>
                  <div className="event-list-container">
                    {activeOption==='active' && tickets.activeTickets.length > 0 ? (
                      tickets.activeTickets.map((ticket) => (
    
                        <div className="event-info-container" key={ticket._id}>
                          <div className="event-info-first">
                            <div className="event-info-left">
                              <img
                                className="event-info-icon"
                                src={ticket.event.tag==='Music'? eventPic : ticket.event.tag==='Charity Event' ? charityPic : ticket.event.tag==='Job Event' ? jobPic : ticket.event.tag==='Sports' ? sportsPic : ticket.event.tag==='Religious Event' ? religiousPic : null}
                                alt="Event Icon"
                              />
                              <div className="event-info-heading">
                                <h3 className="event-info-title">
                                  {ticket.event.title}
                                </h3>
                                <h4 className="event-info-subtitle">
                                   {ticket.event.description.length > 83 ?  ticket.event.description.slice(0,83)+"..." : ticket.event.description}
                                </h4>
                              </div>
                            </div>
                            <div className="event-info-right">
                              <div className="event-info-date">
                                <FontAwesomeIcon icon={faCalendarDays} />
                                <h4>{ticket.event.date.split("T")[0]}</h4>
                              </div>
                     
                            </div>
                          </div>
                          <div className="event-info-second">
                            <div className="event-info-left">
                              <div className="event-info-tag">
                                <h3>{ticket.event.tag}</h3>
                              </div>
                              <div className="event-info-location">
                                <FontAwesomeIcon icon={faLocationDot} />
                                <h3>{ticket.event.location.city}</h3>
                              </div>
                            </div>

                            <div className="event-info-right">
                              <div onClick={() => handleViewTicket(ticket._id)} className="ticket-details-div">
                                See Ticket
                              </div>
                            </div>
                          </div>
                        </div>
                      ) )
                    ) : activeOption === 'expired' && tickets.expiredTickets.length > 0 ? (
                        tickets.expiredTickets.map((ticket) => (
                        <div className="event-info-container" key={ticket._id}>
                          <div className="event-info-first">
                            <div className="event-info-left">
                              <img
                                className="event-info-icon"
                                src={eventPic}
                                alt="Event Icon"
                              />
                              <div className="event-info-heading">
                                <h3 className="event-info-title">
                                  {ticket.event.title}
                                </h3>
                                <h4 className="event-info-subtitle">
                                  {ticket.event.description}
                                </h4>
                              </div>
                            </div>
                            <div className="event-info-right">
                              <div className="event-info-date">
                                <FontAwesomeIcon icon={faCalendarDays} />
                                <h4 style={{color:"red"}}>{ticket.event.date.split("T")[0]}</h4>
                              </div>
                            </div>
                          </div>
                          <div className="event-info-second">
                            <div className="event-info-left">
                              <div className="event-info-tag">
                                <h3>{ticket.event.tag}</h3>
                              </div>
                              <div className="event-info-location">
                                <FontAwesomeIcon icon={faLocationDot} />
                                <h3>{ticket.event.location.city}</h3>
                              </div>
                            </div>

                            <div className="event-info-right">
                            <div onClick={() => handleViewTicket(ticket._id)}  className="ticket-details-div">
                                See Ticket
                              </div>
                             
                            </div>
                          </div>
                        </div>
                      ))
                    ) : (
                      <h1 className="no-event">No Ticket</h1>
                    ) }
                  </div>
                </div>
              </div>
            </>
          )}
        </>
        )}
          {showTicket && <ViewTicket/>}
    </>
  )
}

export default MyTickets